import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { map, takeUntil } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SiteModel } from '@core/model/site.model';
import { utiles } from '@utl/environment';
import { ItemValidationModel } from '@core/model/itemValidation.model';
import { ItemInformationModel } from '@core/model/itemInformation.model';
import { ShoppingCartAdminModel } from '@core/model/shoppingCartAdmin.model';
import { ShoppingCartViewModel } from '@core/model/shoppingCartView.model';
import { CommonService } from './common.service';
import { ViewItemsModel } from '@core/model/ViewItems.model';
import { MasterClientModel } from '@core/model/masterClient.model';
import { Observable } from 'rxjs';
import { MensajeInventario } from '@core/model/mensajeInventario';
import { Injectable } from "@angular/core";
import { AvailableModel } from '@core/model/availableClass.model';
import { ExpirationDateCart } from '@core/model/expirationDateCart.model';
import { LineToConfirm } from '@core/model/lineToConfirm.model';
import { ShoppingCartModel } from '@core/model/shoppingCart.model';
import { ModelInfo } from '@core/model/modelInfo.model';
import { CarruselClass } from '@core/model/carruselClass.model';
import { saveAs } from 'file-saver';
/*Constants */
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class ItemService {

  public vViewItemsModel = new ViewItemsModel();
  masterClientModel: MasterClientModel = new MasterClientModel();
  unsubscribe$: Observable<any>;

  constructor(
    public http: HttpClient, 
    private router: Router, 
    private common: CommonService) {
      let data = utiles.getCacheUser();
      if (data !== null && data !== undefined) {
      } else {
        this.common._setLoading(false);
        this.router.navigate(['login']);
      }
  }

  getViewItems(custAccount: string) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetViewItems';
    this.vViewItemsModel = new ViewItemsModel();
    this.vViewItemsModel.UserId = utiles.getCacheUser().UserId;
    this.vViewItemsModel.CustAccount = custAccount;
    this.vViewItemsModel.Currency = utiles.getCacheSelectedCurrency().CurrencyId;
    if (this.vViewItemsModel.Currency === undefined){
      this.vViewItemsModel.Currency = '';
    }
    return this.http.post<ItemInformationModel[]>(url, this.vViewItemsModel, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  setViewItems(model: ItemValidationModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'SetViewItems';
    return this.http.post<ItemValidationModel>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getItemsOnDeal() {
    let vUserId: any;
    let vCurrency: any;

    this.common._setLoading(true);
    const url = environment.apiURL + 'GetItemsOnDeal';

    vUserId = utiles.getCacheUser().UserId;
    vCurrency = utiles.getCacheSelectedCurrency().CurrencyId;

    const modelParams  = {
      UserId: vUserId,
      Currency: vCurrency
    }

    return this.http.post<ItemInformationModel[]>(url, JSON.stringify(modelParams), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getNewItems() {

    let vUserId: any;
    let vCurrency: any;

    this.common._setLoading(true);
    const url = environment.apiURL + 'GetNewItems';

    vUserId = utiles.getCacheUser().UserId;
    vCurrency = utiles.getCacheSelectedCurrency().CurrencyId;

    const modelParams  = {
      UserId: vUserId,
      Currency: vCurrency
    }

    return this.http.post<ItemInformationModel[]>(url, JSON.stringify(modelParams), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  async guardarCarrito(shoppingCart: ShoppingCartModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ShoppingCartAdministration';
    shoppingCart.ShoppingCartLines.forEach(element => {
      element.Item[0].ImageList = JSON.stringify(element.Item[0].ImageList);
    });
    let result = await this.http.post<ShoppingCartModel>(url, shoppingCart, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      })).toPromise();

    return result;
  }

  async GetShoppingCartModel(model) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetShoppingCartModel';
    model.ShoppingCartLines.forEach(element => {
      element.Item[0].ImageList = JSON.stringify(element.Item[0].ImageList);
    });
    let result = await this.http.post<ShoppingCartModel>(url, model, httpOptions)
      .pipe(map(response => {
        if(response.ShoppingCartLines !== undefined
          && response.ShoppingCartLines !== null) {
          response.ShoppingCartLines.forEach(element => {
            if (JSON.parse(element.Item[0].ImageList).length > 0) {
              element.Item[0].ImageList = JSON.parse(element.Item[0].ImageList);
            } else {
              element.Item[0].ImageList = [{URLImage: environment.imgDefault}];
            }
            if(element.CantDiasReabastece > 0) {
              response.ReqReabastecimiento = true;
            }
          });
        } else {
          response.ShoppingCartLines = [];
        }
        this.common._setLoading(false);
        return response;
      })).toPromise();

    return result;
  }

  async validateInventAvailable(model) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ValidateInventAvailable';
    model.SiteId = utiles.getCacheSelectedAddress() !== null && utiles.getCacheSelectedAddress() !== undefined ?
      utiles.getCacheSelectedAddress().SiteIdDelivery : 0;
    model.Currency = utiles.getCacheSelectedCurrency().CurrencyId;
    let result = await this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      })).toPromise();

    return result;
  }

  ValidateInventAvailableByCart(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ValidateInventAvailableByCart';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  LinesToConfirm (model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'LinesToConfirm';
    return this.http.post<LineToConfirm[]>(url, model, httpOptions)
    .pipe(map(response => {
      this.common._setLoading(false);
      return response;
    }));
  }

  getGlassDescription(glassTypeId: string) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetGlassTypeDescription';
    return this.http.post<any>(url, glassTypeId, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  SaveShoppingCart(shoppingCartInfo: any) {
    const url = environment.apiURL + 'SaveShoppingCart';
    return this.http.post<any>(url, JSON.stringify(shoppingCartInfo), httpOptions)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteShoppingCart(shoppingCartInfo: any) {
    const url = environment.apiURL + 'DeleteShoppingCart';
    return this.http.post<any>(url, JSON.stringify(shoppingCartInfo), httpOptions)
      .pipe(map(response => {
        return response;
      }));
  }

  ValidateSaveCart(shoppingCartInfo: any) {
    const url = environment.apiURL + 'ValidateSaveCart';
    return this.http.post<any>(url, shoppingCartInfo, httpOptions)
      .pipe(map(response => {
        return response;
      }));
  }

  UpdateShoppingCartByExpiration(shoppingCart: any) {
    const url = environment.apiURL + 'UpdateShoppingCartByExpiration';
    return this.http.post<null>(url, shoppingCart, httpOptions)
    .pipe(map(response => {
      return response;
    }));
  }

  async ValidateShoppingCartLines(model: any) {
    await this.common._setLoading(true);
    const url = environment.apiURL + 'ValidateShoppingCartLines';
    let result = await this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      })).toPromise();

    return result;
  }

  ValidateAvailQtyBySaveCart(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ValidateAvailQtyBySaveCart';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  GetCarruselInformation(model: any) {
    const url = environment.apiURL + 'GetCarruselInformation';
    return this.http.post<CarruselClass>(url, model, httpOptions)
      .pipe(map(response => {
        return response;
      }));
  }

  downloadShoppingCart(model: any) {
    const url = environment.apiURL + 'GenerateExcelQuot';
    this.http.post(url, model, { responseType: 'blob' }).subscribe((response: Blob) => {
      const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, `Carrito:${model.Id}.xlsx`);
      return true;
    });
  }
}
